/**
 * 
 */
(function() {
	angular.module("cbl.insuranceloanpmi.mf").service("CreasRicercaClienteSrvc", [ function() {
		/* Valore del campo partita iva/codice fiscale nei filtri di ricerca */
	    this.pivacfisc = null;
	    /* Flag che visualizza il messaggio di nessun record trovato */
	    this.noResultsFlag = false;
	    /* Flag che indica l'abilitazione della ricerca su cerved */
	    this.ricercaCerved = false;
	    /* Tabella Clienti Banca */
	    this.clientiBancaTableData = null;
	    /* Tabella Clienti Cerved */
	    this.clientiCervedTableData = null;
		/* Variabile per determinare se preservare la ricerca in caso di cambio rotta */
	    this.preserveSearch = false;
	} ]);
}());



//////////////////
// WEBPACK FOOTER
// ./app/components/creasRicercaCliente/creasRicercaClienteSrvc.js
// module id = 40
// module chunks = 0 1